Namespace 'Common.Dashboard.Filters'

Common.Dashboard.Filters.SubtypeFilterMixin =
  _getSelectedValues: ->
    @typeSelectorView.getSelectedValues()

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.subtype'

  openSubtypeFilterModal: ->
    @typeSelectorView?.remove()
    @typeSelectorView = new CustomerVisualMode.Filters.SingleFilters.SubTypeFilterView(
      values: @subtypes.models
      selectedOptions: @filter.getValues().map (value) -> value.id
      placeholder: I18n.t 'common.session.filters.subtype.modal.placeholder'
      title: @modalTitle()
      subtitle: @modalSubtitle()
    ).render()
    @listenTo(@typeSelectorView, 'filters:multiplevalues:apply', @applyFilter)
